import Layout from "../components/Layout";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {DataTable} from "primereact/datatable";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Column} from "primereact/column";
import {get} from "react-hook-form";
import {ProgressSpinner} from "primereact/progressspinner";
import QuarterNames from "../components/QuarterNames";
import {useSelector} from "react-redux";
import {createSearchParams, useNavigate} from "react-router-dom";


const EmployeeTaskDashboard = () => {
    const {user} = useSelector((state) => state["auth"]);
    const [factoryData, setFactoryData] = useState([])
    const [departmentData, setDepartmentData] = useState([])
    const [designationData, setDesignationData] = useState([])
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [start, setFirst] = useState(0);
    const [getFilterData, setGetFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        initFilters1()
        GetEmployeeFilterData()
    }, [])

    const GetEmployeeFilterData = () => {
        axios.get(BASE_URL + "/api/report/GetFilterFactoryData")
            .then(response => {
                setFactoryData(response.data);                
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDepartmentData")
            .then(response => {
                setDepartmentData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDesignationData")
            .then(response => {
                setDesignationData(response.data)
            })
            .catch(console.error)
    }


    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }


    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(getFilterData);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Employee Information');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    }

    const PMSStatusExportExcel = () => {
        var e = document.getElementById("ddlQuarter");
        var _QuarterIDValue = e.value=== "-1" ? user.quarterID: e.value;//SearchStr="+btoa("QuarterID="+ _QuarterIDValue));
        console.log(btoa("QuarterID=" + _QuarterIDValue));
        console.log(atob(btoa("QuarterID=" + _QuarterIDValue)));
        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSStatusReport?SearchStr="+btoa("QuarterID=" + _QuarterIDValue));
        //window.open("http://localhost:13805/PMSReport/TaskListDataExport?SearchStr="+btoa("QuarterID=" + _QuarterIDValue));
        //window.open("http://localhost:13805/PMSReport/GetEmployeeWiseTaskListReport?SearchStr="+btoa("RegisterID=" + registerId+"&QuarterID=" + user.quarterID));    
      };

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                               placeholder="Keyword Search"/>
                               </span>
                </div>                
                {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""}
                    <Button type="button" icon="pi pi-file-excel" onClick={PMSStatusExportExcel} className="p-button-success mr-2" data-pr-tooltip="XLS" />
                
            </div>
        </div>
    );

    const submissionStatusbody = ({isSubmitted}) => (<>
            <span>{Number(isSubmitted) === 1 ? 
            <span class="product-badge status-complete">Completed</span> : 
            <span class="product-badge status-incomplete">Not Completed</span>
            }
            </span>
        </>
    )
    
    const _actionEmployee = (empIdp) => (<>    
    <span style={{cursor: "pointer"}} className="txtBlue" onClick={()=>{
        navigate({
            //pathname: "/MarksDetails",
            //pathname: window.open("http://localhost:13805/PMSReport/GetEmployeeWiseTaskListReport?SearchStr="+btoa("RegisterID=" + empIdp.registerId+"&QuarterID=" + user.quarterID)),
            pathname: window.open("https://apps.bitopibd.com/PMSReport/GetEmployeeWiseTaskListReport?SearchStr="+btoa("RegisterID=" + empIdp.registerId+"&QuarterID=" + user.quarterID)),            
            search: createSearchParams({
                employeeId: btoa(empIdp.registerID),
                quarterID: btoa(document.getElementById('ddlQuarter').value==="-1"? user.quarterID : document.getElementById('ddlQuarter').value)
            }).toString()
        });
    }}>{empIdp.employeeName}</span>
       
      </>)
    

    return (<Layout>

        <div className="card">

            <div className="card-header">
                <div className="row">
                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                                id="emp_factory">
                            <option value="">Factory</option>
                            {factoryData.map((value, index) => {
                                return <option key={index} value={value.factoryName}>{value.factoryName}</option>
                            })}

                        </select>
                    </div>
                    <div className="col-md-3">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                                id="emp_dept">
                            <option value="">Department</option>
                            {departmentData.map((value, index) => {
                                return <option key={index} value={value.department}>{value.department}</option>
                            })}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                                id="emp_designation">
                            <option value="">Designation</option>
                            {designationData.map((value, index) => {
                                return <option key={index} value={value.designation}>{value.designation}</option>
                            })}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <QuarterNames/>
                    </div>
                    <div className="col-md-2">
                        <button className="btn btn-primary btn-sm" onClick={() => {
                            setIsLoading(true);
                            var e = document.getElementById("ddlQuarter");
                            var _selectedValue = e.value==="-1"?user.quarterID:e.value;

                            const factory = document.getElementById("emp_factory").value
                            const emp_dept = document.getElementById("emp_dept").value
                            const emp_designation = document.getElementById("emp_designation").value
                            const _QuarterID = _selectedValue;
                            const data = {
                                FactoryName: factory,
                                Department: emp_dept,
                                Designation: emp_designation,
                                QuarterID : parseInt(_QuarterID)
                            }
                            //console.log(data)
                            axios.post(BASE_URL + "/api/report/GetEmployeeTaskData", JSON.stringify(data))
                                .then(response => {
                                    setGetFilterData(response.data)
                                    setIsLoading(false);
                                    console.log(response.data);
                                })
                                .catch(function (error) {
                                    setIsLoading(false);
                                    console.log(error);
                                 });
                        }}><i class="bi bi-funnel"></i> Filter
                        </button>
                        <button className="btn ms-2 text-white btn-info btn-sm"><i class="bi bi-eraser"></i> Clear</button>
                    </div>
                </div>
            </div>
            <div className="card-body">
            {/* {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""} */}
                <DataTable value={getFilterData}
                           header={header}
                           resizableColumns
                           showGridlines
                           dataKey="registerID"
                           filters={filters1}
                           filterDisplay="menu"
                           globalFilterFields={['employeeName', 'department', 'designation']}
                           paginator rows={10} first={start}
                           paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                    <Column field='registerId' header="RegisterID" hidden={true}/>
                    <Column field='factoryName' header="Factory" sortable className="text-center"/>
                    <Column field='employeeCode' sortable header="Employee Code"/>
                    <Column field='employeeName' sortable header="Employee Name" body={_actionEmployee}/>
                    <Column field='department' sortable className="text-center" header={"Department"} />
                    <Column field='designation' sortable className="text-center" header={"Designation"} />
                    <Column field='isSubmitted' sortable className="text-center" header={"Status"} body={submissionStatusbody} />                                        
                </DataTable>
            </div>
        </div>

    </Layout>)
}

export default EmployeeTaskDashboard